import { Link } from 'react-router-dom';

import SitePageLayout from '../components/SitePageLayout';

export default function SupportScreen() {
  return (
    <SitePageLayout title="Support" effectiveDate="February 15, 2026">
      <p>
        Wreckoning Ball is a product of Xerratus, LLC. If you need help with your account, purchases,
        or app functionality, contact us and we will assist as quickly as possible.
      </p>

      <section className="legal-section">
        <h2>Contact</h2>
        <ul>
          <li>General support: support@xerratus.com</li>
          <li>Privacy requests: privacy@xerratus.com</li>
          <li>Typical response time: within 2-3 business days</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Account Help</h2>
        <ul>
          <li>Sign in with Apple or Google to sync access across devices.</li>
          <li>Use Profile to update your name, voice preference, and legal settings.</li>
          <li>
            If you lose access to your account, email support@xerratus.com from the address tied
            to that account.
          </li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Subscriptions and Credit Packs</h2>
        <p>
          Wreckoning Ball offers optional auto-renewable subscriptions and one-time translation credit
          packs.
        </p>
        <ul>
          <li>Subscriptions auto-renew unless canceled in your store account settings.</li>
          <li>Cancellation takes effect at the end of the current billing period.</li>
          <li>Restoring purchases is available from the app on supported store builds.</li>
          <li>
            Billing, refunds, and store purchase issues are handled by Apple App Store or Google
            Play based on your platform.
          </li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Delete Account and Data</h2>
        <p>
          You can request account deletion at any time in the app or by contacting support.
          Deletion removes account data from active systems; retained records may include
          compliance logs and billing records required by law.
        </p>
        <p>
          For full details, visit <Link to="/delete-account">Delete Account</Link>.
        </p>
      </section>

      <section className="legal-section">
        <h2>Troubleshooting</h2>
        <ul>
          <li>Restart the app after updating account or language settings.</li>
          <li>Confirm internet connectivity for translation, phonetics, and audio generation.</li>
          <li>Check that your selected plan has enough credits for new translations.</li>
          <li>If an issue persists, send your device type and steps to reproduce to support.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Related Policies</h2>
        <ul>
          <li>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/terms-of-service">Terms of Service</Link>
          </li>
        </ul>
      </section>
    </SitePageLayout>
  );
}
